<template>
  <div>
    <!-- TEXT MULTI LINE -->
    <textarea v-if="pFieldValue.multiLine" :name="fieldValueInputName" rows="5" cols="50" :id="pFieldValueInputId"
              class="form-control" v-model="value" :readonly="fieldValueInputReadonly"></textarea>

    <!-- TEXT SINGLE LINE -->
    <input v-else type="text" :name="fieldValueInputName" :id="pFieldValueInputId"
           class="form-control" v-model="value" :readonly="fieldValueInputReadonly"/>

    <!-- TEXT GENERATED HINT -->
    <p v-if="textGeneratedHintVisible" class="help-block text-generated-hint">
      {{ 'dictionary.field.text.generated' | i18nText(pDictionary) | i18nparams(0, fieldNameI18n) }}</p>

    <!-- TEXT FORMAT HINT -->
    <p v-if="textFormatHintVisible" class="help-block text-format-hint">
      <label>{{ 'dictionary.general.hint.format' | i18nText(pDictionary) }}:</label> {{ textFormatHintTextI18n }}</p>
  </div>
</template>

<script>
import stringHelpers from '@/helpers/string-helpers'
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "FieldValueTextForm",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pFieldValue: {
      type: Object,
      required: true
    },
    pFieldValueInputId: {
      type: String,
      required: true
    },
    pFieldValueInputNamePrefix: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      value: this.pFieldValue.value
    }
  },
  computed: {
    fieldNameI18n: function() {
      if(this.pLanguage === 'fr' && !stringHelpers.isEmptyOrNull(this.pFieldValue.names.fr)) {
        return this.pFieldValue.names.fr;
      }
      return this.pFieldValue.name;
    },
    fieldValueInputName: function() {
      return this.pFieldValueInputNamePrefix + ".value";
    },
    fieldValueInputReadonly: function() {
      return this.pFieldValue.generated;
    },
    textGeneratedHintVisible: function () {
      return this.pFieldValue.generated;
    },
    textFormatHintVisible: function () {
      return !stringHelpers.isEmptyOrNull(this.textFormatHintTextI18n);
    },
    textFormatHintTextI18n: function () {
      if(this.pLanguage === 'fr' && !stringHelpers.isEmptyOrNull(this.pFieldValue.textFormatHints.fr)) {
        return this.pFieldValue.textFormatHints.fr;
      }
      return this.pFieldValue.textFormatHint;
    }
  }
}
</script>

<style scoped>

</style>